import { Link as RouterLink } from 'react-router-dom';
import Widget from '../common/Widget';
import { PageDetails } from './config';
import { Card, Typography, Link, Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const MonarchMindWidget = (props) => {
  const navigate = useNavigate();

  const subPages = Object.values(PageDetails).filter((page) => page.id !== 'monarchMind');

  return (
    <>
      <Widget
        data={{
          id: props.widget.id,
          title: props.title,
          isTitleStylized: props.isTitleStylized,
          //   menu,
          isExpand: props.widget.isExpand,
          isRequired: props.widget.isRequired,
          logo: props.logo,
        }}
        {...props}
        className="myOdu__monarchMind"
        hasScrollX
      >
        <Link component={RouterLink} to="/monarchMind" className="monarchMindPortalLink">
          MonarchMind Portal
        </Link>
        <Grid container spacing={1} className="monarchMindAppsGrid">
          {subPages.map((page) => (
            <Grid item xs={6} key={page.id} className="monarchMindAppGridItem">
              <Card
                onClick={() =>
                  page.externalUrl
                    ? window.open(page.externalUrl, '_blank')
                    : navigate(`monarchMind/${page.page}`)
                }
                elevation={0}
                className={`myOdu__appCard monarchMindAppCard`}
              >
                <Box className="wrapperBox">
                  <Box className="myOdu__logoZoom iconImage">
                    <img src={page.icon} alt={page.title} />
                  </Box>
                </Box>
                <Typography variant="smallest" className="appCardTitle">
                  {page.shortTitle}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Widget>
    </>
  );
};
